var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6271 2.38364L13.0678 3.94292L16.6034 7.47846L18.1627 5.91917C18.1724 5.88865 18.1832 5.85293 18.1941 5.81249C18.24 5.64317 18.2875 5.39982 18.2915 5.11396C18.2991 4.55885 18.1459 3.82519 17.4335 3.1128C16.7211 2.40041 15.9874 2.24716 15.4323 2.25482C15.1465 2.25876 14.9031 2.30631 14.7338 2.35217C14.6934 2.36313 14.6576 2.37385 14.6271 2.38364ZM18.8798 6.38049C19.6382 6.7259 19.6384 6.7255 19.6386 6.72509L19.639 6.72424L19.6398 6.72238L19.6417 6.71808L19.6466 6.70711C19.6502 6.69877 19.6547 6.68834 19.6598 6.67591C19.6701 6.65107 19.6832 6.61814 19.6982 6.57772C19.7281 6.497 19.7656 6.38558 19.8028 6.24828C19.8768 5.97502 19.9517 5.59085 19.958 5.13695C19.9707 4.21254 19.6954 3.01773 18.612 1.93429C17.5286 0.850856 16.3338 0.575558 15.4093 0.588308C14.9554 0.594569 14.5713 0.669465 14.298 0.743488C14.1607 0.780684 14.0493 0.818233 13.9686 0.848112C13.9282 0.863076 13.8952 0.876192 13.8704 0.886486C13.858 0.891636 13.8475 0.896088 13.8392 0.899723L13.8282 0.904549L13.8239 0.906477L13.8221 0.907315L13.8212 0.907701C13.8208 0.907886 13.8204 0.908066 14.1658 1.66645L13.8204 0.908066L13.6832 0.970567L1.37336 13.2804L0.569824 19.9765L7.26591 19.1729L19.5757 6.86312L19.6382 6.7259L18.8798 6.38049ZM15.4249 8.65697L11.8893 5.12143L2.95947 14.0513L2.47735 18.0689L6.495 17.5868L15.4249 8.65697Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.df6887ecb670ad59007213836e63e736.svg";
export { ForwardRef as ReactComponent };